import React from "react";
import {atom} from "jotai";
import {ModalPositionProps, ModalProps, SaveProps} from "../types/action";




export const saveState = atom<SaveProps>({
  needSaveOn: false
});

export const modalState = atom<ModalProps>({
  modalOn: false,
  modalTitle: 'AI 번역보기',
  modalContentName: 'ModalAIContent'
});


export const modalPositionState = atom<ModalPositionProps>({
  modalPositionX:0,
  modalPositionY:0
});




